import type { ApiClient } from '../client';
import { LockCodesSchema, type LockCodes } from '../schemas/lockCodes';

// Read the two code tables of a cerradura around the server pointer. **Side-effect-free**: this is
// the whole point of the feature — in the legacy, consulting the codes advanced the pointer and so
// worsened the desync the agent was investigating. Equipo P confirmed in writing on CBX-10986 that
// the devices-service read takes no transaction, writes nothing and raises no event.
//
// LOCK-first: the key is `lock.id`, the cerradura's id in devices-service (CBX-10985), which the
// «Entrega» detail carries. It is NOT `lock.qr` (app-service's own 6-char PK, invalid against
// devices) and the «buzón» is not involved — unlike the box log, which is read box-first.
//
// No query params: devices-service fixes the window (10 previous · current · 5 next). Errors come
// back in the standard envelope (`404 lock_not_found`, `502 lock_sequences_unavailable`); the panel
// maps no per-code copy — any failure lands on one neutral strip with «Reintentar».
export async function fetchLockCodes(client: ApiClient, lockId: string): Promise<LockCodes> {
  const data = await client.get<unknown>(
    `/app_service/panel/v1/locks/${encodeURIComponent(lockId)}/sequences`,
  );
  return LockCodesSchema.parse(data);
}
